import { getSessionID, getTransactionID } from '.';

export function getNblyApiHeaders()
{
    const transactionID = getTransactionID();
    const sessionID = getSessionID();

    return  `correlationId=${transactionID}&sessionId=${sessionID}`
}